module.exports = __webpack_public_path__ + "static/freehand-marvel-prototyping-4e12cf7905a89d29711a6e15644e1f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/freehand-marvel-prototyping.png
// module id = 2688
// module chunks = 157636680307020